module.exports = __webpack_public_path__ + "img/p-linepay.29242cb5.svg";